import { Button, Field, Skeleton } from "@/components/ui";
import { EligibilityEditor } from "@/containers/Coach/EligibilityEditor";
import { CoachService, GenericAccess } from "@/services/CoachServices";
import { useSocialCoachSession } from "@/utils/useSocialCoachSession";
import * as React from "react";
import { useFormContext } from "react-hook-form";
import { useState } from "react";
import { EligibilityCriterion, SuperPageEligibilityValues } from "@/services/bedrock";

const SuperPageEligibilityForm: React.FC = () => {
  const { coachId } = useSocialCoachSession();
  const {
    watch,
    setValue,
    formState: { defaultValues, isSubmitting, isDirty },
  } = useFormContext<SuperPageEligibilityValues>();
  const eligibilityCriteria = watch("eligibilityCriterions");
  const [originalAccess, setOriginalAccess] = useState<GenericAccess>({ eligibilityCriteria });
  const [currentAccess, setCurrentAccess] = useState<GenericAccess>({ eligibilityCriteria });
  const [initializing, setInitializing] = useState(true);
  const superPageId = watch("id");

  const getAccess = async (criteria: EligibilityCriterion[]) => {
    return await CoachService.getAccessPreview(String(coachId ?? ""), "VIDEO_PAGES", criteria);
  };

  React.useEffect(() => {
    getAccess((defaultValues?.eligibilityCriterions || []) as EligibilityCriterion[])
      .then(response => {
        setCurrentAccess(response);
        setOriginalAccess(response);
      })
      .finally(() => {
        setInitializing(false);
      });
  }, [defaultValues?.eligibilityCriterions]);

  const updateHandler = React.useCallback(
    async (newCriteria: EligibilityCriterion[]) => {
      const access = await getAccess(newCriteria);
      setCurrentAccess(access);
      setValue("eligibilityCriterions", newCriteria, { shouldDirty: true });
      return access;
    },
    [coachId, setValue]
  );

  return (
    <Field.Group className="w-2xl min-w-md">
      {initializing ? (
        <Skeleton className="w-full h-120" />
      ) : (
        <EligibilityEditor
          originalAccess={originalAccess}
          currentAccess={currentAccess}
          accessType="VIDEO_PAGES"
          updateHandler={updateHandler}
          isNew={!superPageId}
        />
      )}
    </Field.Group>
  );
};

export { SuperPageEligibilityForm };
